import { formatDate } from "@/lib/api";
import { GrowthSummary } from "@/lib/growth";

export const ScoreSummary = ({ submission, history }) => (
    <div className="grid gap-6 md:grid-cols-[minmax(0,15rem)_1fr] items-start" data-testid="score-summary">
        <div className="rounded-[6px] surface-dark p-6 text-center">
            <p className="text-sm uppercase tracking-wider font-bold">Punteggio</p>
            <p className="font-heading text-6xl font-black mt-1 text-edi-on-graphite" data-testid="score-total">
                {submission.score_total}<span className="text-2xl font-bold text-edi-lime">/100</span>
            </p>
            <p className="mt-3 inline-block rounded-lg bg-edi-lime text-edi-on-lime px-4 py-1 font-bold" data-testid="score-level">{submission.level}</p>
            <p className="mt-3 text-sm text-edi-muted" data-testid="score-date">Compilato il {formatDate(submission.submitted_at)}</p>
            <GrowthSummary items={history} />
        </div>
        <div>
            <h3 className="font-bold text-lg">Punteggio per area</h3>
            <ul className="mt-3 space-y-4">
                {submission.area_scores.map((a) => (
                    <li key={a.key} data-testid={`area-score-${a.key}`}>
                        <div className="flex justify-between gap-3 font-medium">
                            <span>{a.label}</span>
                            <span className="font-bold">{a.score}/100</span>
                        </div>
                        <div className="mt-1.5 h-3 rounded-md bg-edi-track overflow-hidden" aria-hidden="true">
                            <div className="h-full bg-edi-lime" style={{ width: `${a.score}%` }} />
                        </div>
                    </li>
                ))}
            </ul>
            <p className="edi-help mt-3">Questionario versione {submission.questionnaire_version}</p>
        </div>
    </div>
);

export const AnswersByStep = ({ view }) => (
    <div className="space-y-6" data-testid="answers-by-step">
        {view.map((step) => (
            <section key={step.step} aria-labelledby={`answers-step-${step.step}`}>
                <h3 id={`answers-step-${step.step}`} className="font-bold text-lg border-b border-edi-border pb-1">
                    Step {step.step} — {step.title}
                </h3>
                <dl className="mt-3 space-y-3">
                    {step.items.map((it) => (
                        <div key={it.id} className="min-w-0">
                            <dt className="text-edi-muted text-sm">{it.text}</dt>
                            <dd className="font-medium break-words" data-testid={`answer-${it.id}`}>{it.answer}</dd>
                        </div>
                    ))}
                </dl>
            </section>
        ))}
    </div>
);
